export default {
  selectSellers: (state) => state.salesTeams.availableSellers,
  selectSalesTeams: (state) => state.salesTeams.salesTeams,
  selectAvailableManagers: (state) => state.salesTeams.availableManagers,
  selectAvailableSupport: (state) => state.salesTeams.availableSupport,
};
